export function* makeFilesIterator(files: any[]) {
  for (let i = 0; i < files.length; i += 1) {
    yield files[i];
  }
}
